module.exports = __webpack_public_path__ + "static/media/typescript-icon.b87c6b4d.png";